import * as React from 'react';
import moment from 'moment';
import { InfoLine } from './InfoLine';
import { translate } from 'react-i18next';
import { Box } from 'wix-style-react';
import { InvoiceStatus } from '@wix/ambassador-wix-quotes-web/types';
var getFormattedIssueDate = function (_a) {
    var status = _a.status, issueDate = _a.issueDate, isRecurring = _a.isRecurring;
    var shouldModifyDatesForRecurringSpecialCase = isRecurring && status === InvoiceStatus.Draft;
    return shouldModifyDatesForRecurringSpecialCase ? moment().startOf('day').utc().toDate() : issueDate;
};
export var IssueDate = translate()(function (_a) {
    var issueDate = _a.issueDate, isRecurring = _a.isRecurring, status = _a.status, dateFormatter = _a.dateFormatter, t = _a.t;
    var formattedIssueDate = getFormattedIssueDate({
        status: status,
        issueDate: issueDate,
        isRecurring: isRecurring,
    });
    return formattedIssueDate ? (React.createElement(Box, { whiteSpace: "nowrap" },
        React.createElement(InfoLine, { dataHook: "issue-date" }, "".concat(t('invoice-view:quote.form.issue_date'), ": ").concat(dateFormatter(new Date(formattedIssueDate)))))) : null;
});
//# sourceMappingURL=IssueDate.js.map